import api from './index';

interface LearnosityPlacementUrl {
  lernosityUrl: string;
}
const getLearnosityPlacementUrl = async () => {
  const { data } = await api.get<LearnosityPlacementUrl>(`/v4/learnosity-placement-url`);
  return data;
};

export const LearnosityService = {
  getLearnosityPlacementUrl,
};
